<div class="flex flex-row dots" [class.narrow-dots]="narrowDots">
  <ng-container [ngTemplateOutlet]="dotsStart" *ngIf="position == 'start'"></ng-container>
  <ng-container [ngTemplateOutlet]="dotsMiddle" *ngIf="position == 'middle'"></ng-container>
  <ng-container [ngTemplateOutlet]="dotsEnd" *ngIf="position == 'end'"></ng-container>
  <ng-container [ngTemplateOutlet]="dotsNone" *ngIf="position == 'none'"></ng-container>
  <div class="flex-grow-1" style="padding-left: 10px">
    <ng-content></ng-content>
  </div>
</div>

<ng-template #dotsNone>
  <div class="list-end">
    <div class="flex-grow-1"></div>
    <div *ngIf="!noIcon" [ngClass]="iconSize" class="dot-icon"><i [class]="iconClass"></i></div>
    <div class="flex-grow-1 dots-width" style="display: flex; justify-content: center"></div>
  </div>
</ng-template>

<ng-template #dotsStart>
  <div class="list-end">
    <div class="flex-grow-1"></div>
    <div *ngIf="!noIcon" [ngClass]="iconSize" class="dot-icon"><i [class]="iconClass"></i></div>
    <div class="flex-grow-1 dots-width" style="display: flex; justify-content: center">
      <div class="dotted-line {{ lineClass }}"></div>
    </div>
  </div>
</ng-template>

<ng-template #dotsMiddle>
  <div class="list-end">
    <div class="flex-grow-1" style="display: flex; justify-content: center">
      <div class="dotted-line {{ lineClass }}"></div>
    </div>
    <div *ngIf="noIcon && showTime" class="hours-minutes">
      {{ showTime | minutesToHoursMinutes }}
    </div>
    <div *ngIf="noIcon && customIcon?.length > 0">
      <img src="assets/images/icons/svg/{{ customIcon }}" alt="icon" class="icon" />
    </div>
    <div *ngIf="!noIcon" [ngClass]="iconSize" class="dot-icon"><i [class]="iconClass"></i></div>
    <div class="flex-grow-1 dots-width" style="display: flex; justify-content: center">
      <div class="dotted-line {{ lineClass }}"></div>
    </div>
  </div>
</ng-template>

<ng-template #dotsEnd>
  <div class="list-end">
    <div class="flex-grow-1" style="display: flex; justify-content: center">
      <div class="dotted-line {{ lineClass }}"></div>
    </div>
    <div *ngIf="!noIcon" [ngClass]="iconSize" class="dot-icon"><i [class]="iconClass"></i></div>
    <div class="flex-grow-1"></div>
  </div>
</ng-template>
